import { Listener } from './Listener';
import { detectFormTest } from '../../helpers/detect-form-test';
import { TrackingHandler } from '../TrackingHandler';
import { formatPhoneNumber } from '../../helpers/format-phone-number';
import { getCookie } from '../../helpers/cookies';
export class NewGtmListener extends Listener {
    FILTERED_FIELDS = ['submit_id_c', 'rct', 'captcha_solution', 'password'];
    formSubmit(eventId, formName, data) {
        if (detectFormTest(data)) {
            return;
        }
        this.handleFormSubmission(eventId, 'form_submit_attempt', formName, data);
    }
    formSubmitResult(eventId, formName, submitData, statusCode, responseData) {
        if (TrackingHandler.getInstance().isInternalTest) {
            return;
        }
        if (formName.toLowerCase().includes('consent')) {
            return;
        }
        if (detectFormTest(submitData)) {
            return;
        }
        if (statusCode < 200 || statusCode >= 300) {
            this.handleFormSubmitError(eventId, statusCode, responseData?.message || 'Unknown error');
            return;
        }
        if (!responseData) {
            this.handleFormSubmitError(eventId, statusCode, 'Response data missing');
            return;
        }
        this.handleFormSubmission(eventId, 'form_submit_success', formName, submitData, {
            event_status: typeof responseData.t === 'boolean' && responseData.t,
            to_id: responseData.o || 'unknown',
        });
    }
    handleFormSubmitError(eventId, statusCode, message) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'form_submit_error',
            event_status_code: statusCode,
            event_text: message,
            event_id: eventId,
        });
    }
    handleFormSubmission(eventId, eventName, formName, submitData, additionalData = {}) {
        const formLocation = typeof window.page === 'object' && typeof window.page.type === 'string' && window.page.type
            ? window.page.type
            : window.location.href.match(/\/lp[123]?\//)
                ? 'Landing Page'
                : 'Homepage';
        const data = {
            event: eventName,
            form_name: formName,
            form_location: formLocation,
            lead_id: submitData['submit_id_c'] || '',
            event_id: eventId,
        };
        for (const key of Object.keys(submitData)) {
            if (!this.FILTERED_FIELDS.includes(key)) {
                data[key] = key.toLowerCase().includes('phone') ? formatPhoneNumber(submitData[key]) : submitData[key];
            }
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ...data, ...additionalData });
    }
    phoneClick(eventId, number, location, elementPath) {
        if (getCookie('internalTest')) {
            return;
        }
        window.dataLayer.push({
            event: 'phone_click',
            event_id: eventId,
            phone_number: number,
            click_location: location,
            click_path: elementPath,
        });
    }
}
